// Determine the base URL based on environment
const getBaseUrl = () => {
  // In development, use localhost
  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost:8000';
  }
  // In production, use relative URLs (will go through Nginx proxy)
  return '';
};

const profileCache = new Map();
const profileRequestCache = new Map();

const getProfileCacheKey = (profileName, venue = "marrickville") => `${venue}:${profileName}`;

export async function fetchScrapedData() {
  const baseUrl = getBaseUrl();
  const response = await fetch(`${baseUrl}/api/results`);
  if (!response.ok) throw new Error("Failed to fetch scraped data");
  return response.json();
}

export async function triggerScrape() {
  const baseUrl = getBaseUrl();
  const response = await fetch(`${baseUrl}/api/scrape`);
  if (!response.ok) throw new Error("Failed to trigger scrape");
  return response.json();
}

export async function fetchScrapeStatus() {
  const baseUrl = getBaseUrl();
  const response = await fetch(`${baseUrl}/api/scrape/status`);
  if (!response.ok) throw new Error("Failed to fetch scrape status");
  return response.json();
}

export function getCachedProfile(profileName, venue = "marrickville") {
  return profileCache.get(getProfileCacheKey(profileName, venue)) || null;
}

export async function fetchProfile(profileName, venue="marrickville") {
  const baseUrl = getBaseUrl();
  const cacheKey = getProfileCacheKey(profileName, venue);
  const cached = profileCache.get(cacheKey);
  if (cached) {
    return cached;
  }

  const inFlight = profileRequestCache.get(cacheKey);
  if (inFlight) {
    return inFlight;
  }

  const request = fetch(`${baseUrl}/api/profiles/${venue}/${encodeURIComponent(profileName)}`)
    .then(async (response) => {
      if (!response.ok) {
        if (response.status === 404) {
          throw new Error("Profile details not found.");
        }
        throw new Error(`Error: ${response.status}`);
      }

      const data = await response.json();
      profileCache.set(cacheKey, data);
      return data;
    })
    .finally(() => {
      profileRequestCache.delete(cacheKey);
    });

  profileRequestCache.set(cacheKey, request);
  return request;
}

export function prefetchProfile(profileName, venue = "marrickville") {
  const cacheKey = getProfileCacheKey(profileName, venue);
  if (profileCache.has(cacheKey)) {
    return Promise.resolve(profileCache.get(cacheKey));
  }

  return fetchProfile(profileName, venue).catch(() => null);
}
